import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dailyOutputData
    ? _c(
        VSheet,
        {
          staticClass: "pa-3 d-flex justify-center",
          attrs: { elevation: 2, height: 225 },
        },
        [
          _c("bar-chart", {
            attrs: {
              title: _vm.chartTitle,
              data: _vm.dailyOutputData,
              responsive: true,
              maintainAspectRatio: false,
              height: 200,
              width: "100%",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }